<template>
<section class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white t-mb-5">
	<div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
		<h3 class="t-text-xl t-font-bold">
			GPS Feeds
			<span class="t-float-right">
				<i v-if="loading && ! error" class="fa fa-spinner fa-spin"></i>
                <button v-else @click="showForm()" class="t-bg-green-500 hover:t-bg-green-700 t-text-white t-text-sm t-py-2 t-px-4 t-rounded">Add Feed</button>
			</span>
		</h3>
	</div>
    <div v-if="error" class="t-bg-yellow-100 t-border t-border-yellow-400 t-text-yellow-700 t-px-4 t-py-2 t-my-3 t-rounded t-relative">
       {{ error }}
    </div>
    <div v-if="!loading && feeds.length == 0" class="t-bg-blue-100 t-border t-border-blue-400 t-text-blue-700 t-px-4 t-py-2 t-my-3 t-rounded t-relative">
        You don't currently have any GPS feeds setup.
    </div>
    <table v-if="feeds.length > 0" class="t-w-full t-text-md bg-white t-rounded t-mb-4">
        <thead>
            <th class="t-text-left t-p-3 t-px-5">Name</th>
            <th class="t-text-left t-p-3 t-px-5">Type</th>
            <th class="t-text-left t-p-3 t-px-5">Status</th>
            <th class="t-text-left t-p-3 t-px-5">Truck count</th>
        </thead>
        <tbody>
            <tr v-for="feed in feeds" :key="feed.id" class="t-border-b hover:t-bg-gray-300 t-bg-gray-100">
                <td class="t-align-top t-p-3 t-px-5">{{ feed.name }}</td>
                <td class="t-align-top t-p-3 t-px-5">{{ feed.type }}</td>
                <td v-if="toggleLoading == feed.id" class="t-align-top t-p-3 t-px-5">
                    <i class="fa fa-spinner fa-spin"></i>
                </td>
                <td v-else-if="feed.active" class="t-align-top t-p-3 t-px-5">
                    online&nbsp;<button @click="disableFeed(feed.id, $event)" type="button" class="btn btn-sm btn-secondary">disable</button>
                <td v-else class="t-align-top t-p-3 t-px-5">
                    offline&nbsp;<button @click="enableFeed(feed.id, $event)" type="button" class="btn btn-sm btn-success">enable</button>
                </td>
                <td class="t-align-top t-p-3 t-px-5">{{ feed.truckCount }}</td>
            </tr>
        </tbody>
    </table>
     <gps-feeds-form v-if="formShowing" :showing="formShowing" @cancelled="hideForm()" @submitted="formSubmitted()"></gps-feeds-form>
</section>
</template>

<script>
    import GpsFeedsForm from './GpsFeedsForm';

    export default {
        name: 'gps-feeds',
        components: {
            GpsFeedsForm
        },

        props: [],

        data() {
            return {
                toggleLoading: null,
                formShowing: false,
                loading: true,
                error: null,
                feeds: []
            }
        },

        mounted() {
            this.loadFeeds();
        },

        methods: {
            loadFeeds() {
                this.loading = true;

                this.toggleLoading = null;

                this.feeds = [];

                api.get('carrier/gps/gps-feeds?truck_count')
                   .then((response) => {
                       this.feeds = response.data.data;
                       this.loading = false;
                   })
                   .catch((error) => {
                       this.error = "There was a problem loading your trucks, we've been notified and will look into it.";
                   });
            },

            showForm() {
                this.formShowing = true;
            },

            hideForm() {
                this.formShowing = false;
            },

            formSubmitted() {
                this.loadFeeds();

                this.hideForm();

                this.$swal({
                    title: "GPS feed added successfully!",
                    type: "success",
                    confirmButtonText: 'Okay',
                });
            },

            disableFeed(feedId, button) {
                this.toggleFeed(feedId, false);
            },

            enableFeed(feedId, event) {
                this.toggleFeed(feedId, true);
            },

            toggleFeed(feedId, enable) {
                let action = 'deactive';

                if (enable) {
                    action = 'active';
                }

                this.toggleLoading = feedId;

                api.patch('carrier/gps/gps-feeds/'+feedId+'/'+action)
                    .then((response) => {
                        this.loadFeeds();
                        this.$swal({
                            title: "GPS feed toggled!",
                            type: "success",
                            confirmButtonText: 'Okay',
                        });
                    });
            }
        }
    }
</script>
